import { Operators, OperatorsDef, } from "@/components/fields/base/BaseSearchField";
/** Opérateur de recherche pour le champ de type Date*/
export var operators = [
    OperatorsDef[Operators.OPERATOR_EQUAL],
    OperatorsDef[Operators.OPERATOR_LESS_THAN],
    OperatorsDef[Operators.OPERATOR_LESS_THAN_OR_EQUAL],
    OperatorsDef[Operators.OPERATOR_GREATER_THAN],
    OperatorsDef[Operators.OPERATOR_GREATER_THAN_OR_EQUAL],
    // OperatorsDef[Operators.OPERATOR_BETWEEN],
    OperatorsDef[Operators.OPERATOR_IS_NULL],
    OperatorsDef[Operators.OPERATOR_NOT_NULL],
];
